import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Contactusheading from "./Contactusheading";
import Workwithus from "./Workwithus";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Contactusform from "./Contactusform";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import { Helmet } from "react-helmet-async";

function Contactus() {
  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Contact Us | Hire MERN & App Developers - Dwebbox</title>
        <meta
          name="description"
          content="Get in touch with Dwebbox today. Let's discuss your next big idea in web development, mobile apps, or AI. We are ready to help you scale your business."
        />
        <link rel="canonical" href="https://dwebbox.com/contactus" />
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://dwebbox.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Contact Us",
                "item": "https://dwebbox.com/contactus"
              }
            ]
          })}
        </script>
      </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Contactusheading />
      <Contactusform />
      {/* <Workwithus /> */}
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Contactus;
